import { QUERY_KEYS } from 'api/query-keys';
import { workersPoolsService } from 'ogp/services';
import { useMutation, useQueryClient } from 'react-query';

type AddWorkerToWorkersPoolVariables = {
  workersPoolId: string;
  flexWorkerId: string;
};

export const useAddWorkerToWorkersPool = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ workersPoolId, flexWorkerId }: AddWorkerToWorkersPoolVariables) =>
    await workersPoolsService.addWorkerToWorkersPool(workersPoolId, flexWorkerId);

  return useMutation(mutationFn, {
    onSettled: async (_data, _error, variables) => {
      await queryClient.invalidateQueries(QUERY_KEYS.externalWorkersPools());
      await queryClient.invalidateQueries(
        QUERY_KEYS.externalWorkersPoolDetail(variables.workersPoolId)
      );
      await queryClient.invalidateQueries(
        QUERY_KEYS.externalWorkersPoolFlexWorkers(variables.workersPoolId)
      );
      await queryClient.invalidateQueries(QUERY_KEYS.workers());
    },
  });
};
